import { workerFetch } from '../worker';

// Sidebar teaser: a tiny sparkline + cumulative % for the agent sleeve, mounted under the
// brand. Clicking opens the Agent Ops tab. Best-effort — silent if the API isn't reachable.

interface TeaserResp { points?: { equityIdx: number }[]; summary?: { cumReturnPct: number }; }

let cache: TeaserResp | null = null;
let cacheTs = 0;
const TTL = 5 * 60 * 1000;

export function renderAgentTeaser(host: HTMLElement, onClick: () => void): void {
  host.querySelector('#sb-agent-teaser')?.remove();
  const btn = document.createElement('button');
  btn.id = 'sb-agent-teaser';
  btn.title = 'Agent Ops — paper sleeve cumulative return vs S&P 500';
  btn.style.cssText = 'display:flex;align-items:center;gap:7px;width:calc(100% - 24px);margin:8px 12px 2px;padding:6px 9px;background:rgba(0,255,157,0.04);border:1px solid var(--border);border-radius:4px;cursor:pointer;font-family:var(--mono);';
  btn.innerHTML = `<span style="font-size:8px;letter-spacing:0.12em;color:var(--text3);">AGENTS</span>
    <span class="sb-at-val" style="font-size:11px;font-weight:700;color:var(--text3);min-width:34px;">—</span>
    <svg class="sb-at-spark" viewBox="0 0 100 24" preserveAspectRatio="none" style="flex:1;height:18px;"></svg>`;
  btn.addEventListener('click', onClick);
  const brand = host.querySelector('.sb-brand');
  if (brand) brand.insertAdjacentElement('afterend', btn); else host.appendChild(btn);
  void paint(btn);
}

async function paint(btn: HTMLElement): Promise<void> {
  try {
    if (!cache || Date.now() - cacheTs > TTL) { cache = await workerFetch<TeaserResp>('/api/agent-equity'); cacheTs = Date.now(); }
    const pts = cache?.points ?? [];
    if (!pts.length) return;
    const cum = cache?.summary?.cumReturnPct ?? (pts[pts.length - 1].equityIdx - 100);
    const up = cum >= 0;
    const valEl = btn.querySelector('.sb-at-val') as HTMLElement | null;
    if (valEl) { valEl.textContent = `${up ? '+' : ''}${cum.toFixed(1)}%`; valEl.style.color = up ? 'var(--green)' : 'var(--red)'; }
    const idx = pts.map(p => p.equityIdx);
    const min = Math.min(...idx), span = (Math.max(...idx) - min) || 1;
    const poly = idx.map((v, i) => `${(i / (idx.length - 1 || 1)) * 100},${22 - (v - min) / span * 20}`).join(' ');
    const svg = btn.querySelector('.sb-at-spark');
    if (svg) svg.innerHTML = `<polyline points="${poly}" fill="none" stroke="${up ? '#2ed573' : '#ff4757'}" stroke-width="1.5"/>`;
  } catch { /* teaser is best-effort */ }
}
